import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 전체 관리자 정보 목록을 반환한다.
   * @author kimjy
   * @return {[type]} [description]
   */
  getMgrList(params) {
    return axios.post(`${baseUrl}/common/mgr/get-mgr-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/model/mgr.js